export type Provider = 'github' | 'google'

const PATHS: Record<Provider, string> = {
  github: 'M12 .3a12 12 0 0 0-3.8 23.4c.6.1.8-.3.8-.6v-2c-3.3.7-4-1.6-4-1.6-.6-1.4-1.4-1.8-1.4-1.8-1-.7.1-.7.1-.7 1.2.1 1.8 1.2 1.8 1.2 1.1 1.8 2.8 1.3 3.5 1 .1-.8.4-1.3.8-1.6-2.7-.3-5.5-1.3-5.5-5.9 0-1.3.5-2.4 1.2-3.2-.1-.3-.5-1.5.1-3.2 0 0 1-.3 3.3 1.2a11.5 11.5 0 0 1 6 0C17.3 4.7 18.3 5 18.3 5c.7 1.7.2 2.9.1 3.2.8.8 1.2 1.9 1.2 3.2 0 4.6-2.8 5.6-5.5 5.9.4.4.8 1.1.8 2.2v3.3c0 .3.2.7.8.6A12 12 0 0 0 12 .3',
  google: 'M12.5 10.9v3.3h7.8c-.2 1.8-.9 3.2-1.8 4.1-1.1 1.1-2.9 2.4-6 2.4-4.8 0-8.6-3.9-8.6-8.7s3.8-8.7 8.6-8.7c2.6 0 4.5 1 5.9 2.3l2.3-2.3C18.7 1.4 16.1 0 12.5 0 5.9 0 .3 5.4.3 12s5.6 12 12.2 12c3.6 0 6.3-1.2 8.4-3.4 2.2-2.2 2.8-5.2 2.8-7.7 0-.8 0-1.5-.2-2z',
}

/** GitHub's or Google's mark, filled with the colour of the words beside it and left out of the key's name. */
export function ProviderIcon({ provider }: { provider: Provider }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d={PATHS[provider]} />
    </svg>
  )
}
